import { useQuery } from '@tanstack/react-query';
import type { SupabaseClient } from '../../lib/supabase';
import { ROOM_POLL_INTERVAL_MS } from '../messages/hooks';
import { listRoomHuddles } from './huddleCardApi';

const HUDDLE_PROCESSING_POLL_INTERVAL_MS = 15_000;

/**
 * Huddle cards follow the room poll unless the Mac still has work to do.
 * A pre-migration query error deliberately leaves data undefined, which the
 * page turns into an empty card map and therefore ordinary message bodies.
 */
export function useRoomHuddles(client: SupabaseClient, roomId: string) {
  return useQuery({
    queryKey: ['huddle-cards', roomId],
    queryFn: () => listRoomHuddles(client, roomId),
    enabled: roomId !== '',
    retry: false,
    refetchInterval: (query) =>
      query.state.data?.some((huddle) => huddle.state === 'ended' || huddle.state === 'processing')
        ? HUDDLE_PROCESSING_POLL_INTERVAL_MS
        : ROOM_POLL_INTERVAL_MS,
  });
}
